var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigWarningWithCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30.7939,
    r: 30,
    fill: "#FFD335"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8668 37.3062C28.9249 37.3062 28.2288 37.5518 27.7371 38.0024C27.2457 38.4529 27 39.1491 27 40.0502C27 40.9104 27.2457 41.6066 27.7371 42.0571C28.2284 42.5485 28.9246 42.7941 29.8257 42.7941C30.7268 42.7941 31.3821 42.5484 31.8735 42.0571C32.3649 41.5657 32.6106 40.9103 32.6106 40.0502C32.6106 39.1899 32.3649 38.4938 31.8735 38.0024C31.4641 37.5518 30.7679 37.3062 29.8668 37.3062Z",
    fill: "#FFB801"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9421 34.521H31.874L32.6931 18.7939H27.123L27.9421 34.521Z",
    fill: "#FFB801"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigWarningWithCircleIcon);
export default __webpack_public_path__ + "static/media/big_warning_with_circle_icon.c9fea010.svg";
export { ForwardRef as ReactComponent };